import React, { FC } from 'react';

import { ROUTES } from 'configs';
import {
  MainMenuItemWrapper,
  MainMenuItem,
  ProfileImagePlaceholder,
} from 'components';
import { StyledBlock } from './styled';

interface MainMenuUserItemProps {
  image?: string;
  hasNotifications?: boolean;
}

const MainMenuUserItem: FC<MainMenuUserItemProps> = ({
  image,
  hasNotifications = false,
}) => (
  <MainMenuItemWrapper to={ROUTES.PROFILE}>
    <StyledBlock hasNotifications={hasNotifications}>
      {image ? (
        <MainMenuItem image={image} />
      ) : (
        <ProfileImagePlaceholder width="40px" />
      )}
    </StyledBlock>
  </MainMenuItemWrapper>
);

export default MainMenuUserItem;
